import React, { useState } from "react";
import { useSelector } from "react-redux";
import {AccessRights} from "lib/constants/accessRights"
import BrandModelComponent from './brandModel.component';
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function BrandModelContainer(){
  const [ isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)

  const handleCreateBrandModel = (value) => {
    setIsCreateDialogOpen(value)
  }
  const lang = useSelector(state => state.constant.languages);
  const hasProductBrandModelAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_CREATE));

  return (
    <>
      <BrandModelComponent
        hasProductBrandModelAddAccessRight={hasProductBrandModelAddAccessRight}
        handleCreateBrandModel={handleCreateBrandModel} 
        isCreateDialogOpen={isCreateDialogOpen}
        lang={lang}
      />
    </>
  )
}

export default BrandModelContainer;
